"use client";

import { useEffect } from "react";
import NProgress from "nprogress";

export function NavigationEvents() {
  useEffect(() => {
    // Start progress bar on any link click
    const handleClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const link = target.closest("a");

      if (
        link &&
        link.href &&
        !link.href.startsWith("#") &&
        link.target !== "_blank"
      ) {
        // Check if it's an internal link
        const currentUrl = new URL(window.location.href);
        try {
          const linkUrl = new URL(link.href);
          if (
            linkUrl.origin === currentUrl.origin &&
            linkUrl.pathname !== currentUrl.pathname
          ) {
            NProgress.start();
          }
        } catch {
          // Invalid URL, ignore
        }
      }
    };

    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, []);

  return null;
}
